import { FC } from "react";
import { Box, Typography } from "@material-ui/core";

import { Button, Modal } from "components";
import theme from "theme";

const ReceiveNotificationsModal: FC<{
  isPreviouslyFavoriteListing: boolean;
  onClose: () => void;
  onConfirm: (receiveNotifications: boolean) => Promise<void>;
}> = ({ isPreviouslyFavoriteListing, onClose, onConfirm }) => {
  return (
    <Modal
      open
      onClose={onClose}
      title="Would you like to follow this listing?"
    >
      <Box my={2} fontSize={13}>
        {!!isPreviouslyFavoriteListing ? (
          <Typography align="center">
            You have previously added this listing to your favorites, and now
            can follow to receive emails when there is activity on this listing.
          </Typography>
        ) : (
          <Typography align="center">
            If you choose to follow, you will receive emails when there is
            activity on this listing.
          </Typography>
        )}
        <Box
          mt={4}
          mb={2}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(2),
          }}
        >
          <Button
            fullWidth
            onClick={() => onConfirm(true)}
            size="large"
            variant="contained"
          >
            Yes, receive emails
          </Button>
          <Button
            fullWidth
            onClick={() => onConfirm(false)}
            size="large"
            variant="outlined"
          >
            No, don&apos;t receive emails
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ReceiveNotificationsModal;
